import { ref } from "@vue/composition-api";
import useSessionStorage, { USER_SETTINGS } from "@/hooks/useSessionStorage";

export function useMessageSetting() {
  const { getUserSetting, setUserSetting } = useSessionStorage();

  const userMessageSetting = ref<Record<string, any>>({});

  const getUserMessageSetting = () => {
    userMessageSetting.value = getUserSetting(USER_SETTINGS.MESSAGE_SETTINGS);
  };

  const saveUserMessageSetting = (newSettings: Record<string, any>) => {
    userMessageSetting.value = { ...userMessageSetting.value, ...newSettings };
    setUserSetting(USER_SETTINGS.MESSAGE_SETTINGS, userMessageSetting.value);
  };

  return {
    userMessageSetting,
    getUserMessageSetting,
    saveUserMessageSetting,
  };
}
